// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-print-template {
  display:none;

}
.sales-print-template-show {
  display:block !important;
}
.a5d-print-container {
  overflow-x: auto;
}
.a5d-page-container {
  border: 1px solid #ddd;
  padding: 0 20px;
  width: 210mm;
  height: 297mm;
  margin: auto;
}
.a5d-receipt-double {
  height: 148mm !important;
  margin: auto;
  border: initial;
  border-radius: initial;
  box-shadow: initial;
  background: initial;
  font-family: "Arial";
}
@media print {
  /*@page {*/
  /*  size: A4;*/
  /*  margin: 0;*/
  /*}*/
  header, footer {
    display: none !important;
  }
  body,
  html {
    -webkit-font-smoothing: none;
    width: 100% !important;
    height: 100% !important;
    /*height: 99% !important;*/
    padding: 0 !important;
    margin: 0 !important;
  }

  .a5d-print-container {
    margin: 0 !important;
    overflow: unset;
  }

  .a5d-page-container {
    width: auto !important;
    border: 0 !important;
    margin: 0 auto !important;
  }

  .sales-print-template {
    display: unset;
  }
}

.a5d-double-clone {
  position: relative;
  page-break-after: always;
}
.a5d-invoice-box {
  font-size: 10px;
  color: #555;
  position: relative;
}

.a5d-product-qr-code-img{
  width: 148px;
  height: 148px;
}
/* ------------------totals------------------ */

.a5d-total_container {
  border: 1px solid transparent;
  border-radius: 12px;
  overflow: hidden;
  top: 0;
  right: 6px;
  /* margin-right: 6px; */
}

.a5d-total_container > .a5d-totals {

  border: 1px solid #ddd;
  box-shadow: 0 0 10px rgba(0, 0, 0, .15);
  font-size: 4px;
  background-color: #555;
}

.a5d-total_container > .a5d-totals p {

  padding: 4px;
  margin: 4px;
  font-size: 12px;
}

.a5d-totals_table {
  border-spacing: 0;
  border-collapse: collapse;
  border: 0;
}

.a5d-totals_table tr {
  padding: 16px;
  border: none;
  line-height: 0.8;
}

.a5d-totals_table td {
  border: none;
}

.a5d-totalpayment {
  font-weight: 700;
  font-size: 16px;
}

/* ------------------end totals------------------ */

.a5d-invoice-box table {
  width: 100%;
  text-align: left;

}

.a5d-invoice-box table td {
  padding: 1px;
}


.a5d-invoice-box table tr.top table td.logo_container {
  font-size: 30px;
  width: 30%;
  color: #333
}

.a5d-invoice-box table tr.information table td {
  padding-bottom: 40px
}

/*Dimos fix line height for email*/
.a5d-main_info_table tr {
  border: 1px solid #ddd;
  font-weight: 700;
  text-align: center;
}

.a5d-invoice-box table tr.details td {
  padding-bottom: 20px
}

.a5d-invoice-box table tr.item td {
  border-bottom: 1px solid #eee
}

.a5d-invoice-box table tr.item.last td {
  border-bottom: none
}

.a5d-invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: 700
}

.a5d-products {
  border: 1px solid #eee;
  text-align: center;
}

.a5d-products p {
  height: 40px; /*Dimos increase description size*/
  font-size: 10px;
  margin: 4px;
}

.a5d-product_table .a5d-products td {
  font-size: 10px;
  text-align: center;
  border-right: 1px solid #ddd;

}

.a5d-product_table .a5d-heading td {
  font-size: 10px;
  text-align: center;
  border-right: 1px solid #ddd;
  padding: 2px;
}

.a5d-product_table .a5d-heading p {
  margin: 0;
}

.a5d-product_container {
  margin-top: 2px;
  border: 2px solid #555;
  border-radius: 4px;
  overflow: hidden;
}

.a5d-rtl table {
  text-align: right
}

.a5d-rtl table tr td:nth-child(2) {
  text-align: left
}

.a5d-sender_sign {
  left: 0;
  margin: 0 4px;
  line-height: 1;
}

.a5d-send_sign_container {
  margin: 0;
}

.a5d-mydata_sign {
  margin: 0 4px;
  line-height: 1;
}

.a5d-heading {
  background-color: #555;
  color: white;
}

.a5d-main_info_table .a5d-heading > td {
  line-height: 0;
}

.a5d-information {

  border: 1px solid #555;
  border-radius: 4px;
  padding: 2px;

}

.a5d-main_info {

  border: 1px solid #555;
  border-radius: 4px;
  overflow: hidden;

}

.a5d-skin {
  color: #555;
}

.a5d-bold {
  color: #555;
  font-weight: bold;
}

.a5d-footer_container {
  position: absolute !important;
  bottom: 0;
  /* border: 1px solid #ddd; */
  width: 100%;
  margin: auto;
  padding-bottom: 0;
}


.a5d-header_table td {
  border: none;

}

.a5d-issuer_container {
  text-align: center;
}

.a5d-issuer_container .a5d-issuer_name {
  font-size: 12px;
  font-weight: bold;
}

.a5d-issuer_container .a5d-issuer_subjectField {
  font-style: italic;
}

.a5d-issuer_container p {
  margin: 0;
  font-size: 10px;
}

.a5d-gemh_issuer_p {
  font-style: italic;
}

.a5d-information_table {
  margin-top: 2px;

}

.a5d-information_table td {
  padding: 0;
  border: none;
  font-size: 8px;
}

.a5d-code_head_td {
  width: 14%;
}

.a5d-description_head_td {
  width: 32%;
}

.a5d-price_head_td {
  width: 8%;
}

.a5d-vat_head_td {
  width: 8%;
}

.a5d-blank_row.bordered td {
  border-top: 1px solid white;
  background-color: white;
  max-height: 2px;
  height: 2px;
  line-height: 2px;
}

.a5d-text-right {
  text-align: right;
  margin-right: 20px;
  background-color: white;
  min-width: 30px;
}

.a5d-text-left {
  background-color: #555;
  color: white;
}

.a5d-info_value {
  font-weight: bold;
}

.a5d-cont_notation {
  border: 1px solid #555;
  padding: 8px;
  border-radius: 8px;
  overflow: hidden;
  overflow-wrap: break-word;
  margin-top: 2px;
  max-height: 150px;
  /*width: 330px;*/
}
.a5d-per_vat_totals_container {
  border: 1px solid #555;
  border-radius: 8px;
  margin-top: 2px;
}

.a5d-cont_signs {
  border: 1px solid #555;
  border-radius: 8px;
  overflow: hidden;
  width: 150px;
}
.a5d-totals_table tr{
  padding: 10px;
}

.a5d-totals_per_vat th {
  width: 10%;
  color: #555;
  font-weight: bold;
}

.a5d-total_funny_box {
  width: 80px;
  height: 46px;
  background-color: #555;
  border: 1px solid white;
  border-radius: 0 0 8px 0;
  position: absolute;
  bottom: 60px;
  right: -2px;
  z-index: -1;
  display: none;
}

.a5d-union_doc_sign {
  position: absolute;
  transform: rotate(-90deg);
  left: -164px;
  bottom: 560px;
  font-size: 11px;
  margin: 0;

}

.a5d-count_totals_container {
  padding: 2px;
  border: 2px solid #555;
  border-radius: 8px;
  min-height: 4px;
  overflow: hidden;
  margin-bottom: 2px;
}

.a5d-count_total_prods {
  font-size: 12px;
  font-weight: bold;
}

.a5d-cont_sign_left {
  float: left;
  text-align: center;
  width: 50%;
  font-size: 12px;
}

.a5d-cont_sign_right {
  float: right;
  text-align: center;
  width: 50%;
  font-size: 12px;
}

.a5d-fullname_sign {
  font-size: 9px;
}

.a5d-sign_hr {
  width: 80%;
  margin: 0 0 0 10%;
}

.a5d-finalprice p {
  font-weight: bold;
  font-size: 16px !important;
}

.a5d-information_td_left {
  width: 100%;
  font-size: 8px;
}

.a5d-information_td_right {
  /* width: 46%; */
  max-height: 60px;
}

.a5d-up_head_td p {
  font-size: 7px;
}

.a5d-whtax_head_td p {
  font-size: 7px;
  word-break: keep-all;
}

.a5d-pricenovat_head_td p {
  font-size: 7px;
}
.a5d-text-head{
  font-size: 10px !important;
  text-decoration: underline;
}
.a5d-information_customer_td{
  width:30%;
}
.a5d-cancel {
  position: absolute;
  transform: translate(50%) rotate(-45deg);
  top: 30%;
  font-size: 120px;
  margin: 0 0 -200px 0;
  color: #cdcdcd;
  text-transform: uppercase;
  opacity: 0.7;
}
.a5d-p {
  height: 16px;
  font-size: 10px;
  margin: 4px;
}
.a5d-footer_table td {
  vertical-align: bottom;
}`, "",{"version":3,"sources":["webpack://./src/Components/InvoicePrint/invoicePrint-a5-double.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;AAEd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,IAAI;EACJ;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA,+CAA+C;;AAE/C;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,uCAAuC;EACvC,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mDAAmD;;AAEnD;EACE,WAAW;EACX,gBAAgB;;AAElB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,kCAAkC;EAChD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;;AAE9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,YAAY;;AAEd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS;;AAEX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".sales-print-template {\r\n  display:none;\r\n\r\n}\r\n.sales-print-template-show {\r\n  display:block !important;\r\n}\r\n.a5d-print-container {\r\n  overflow-x: auto;\r\n}\r\n.a5d-page-container {\r\n  border: 1px solid #ddd;\r\n  padding: 0 20px;\r\n  width: 210mm;\r\n  height: 297mm;\r\n  margin: auto;\r\n}\r\n.a5d-receipt-double {\r\n  height: 148mm !important;\r\n  margin: auto;\r\n  border: initial;\r\n  border-radius: initial;\r\n  box-shadow: initial;\r\n  background: initial;\r\n  font-family: \"Arial\";\r\n}\r\n@media print {\r\n  /*@page {*/\r\n  /*  size: A4;*/\r\n  /*  margin: 0;*/\r\n  /*}*/\r\n  header, footer {\r\n    display: none !important;\r\n  }\r\n  body,\r\n  html {\r\n    -webkit-font-smoothing: none;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    /*height: 99% !important;*/\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .a5d-print-container {\r\n    margin: 0 !important;\r\n    overflow: unset;\r\n  }\r\n\r\n  .a5d-page-container {\r\n    width: auto !important;\r\n    border: 0 !important;\r\n    margin: 0 auto !important;\r\n  }\r\n\r\n  .sales-print-template {\r\n    display: unset;\r\n  }\r\n}\r\n\r\n.a5d-double-clone {\r\n  position: relative;\r\n  page-break-after: always;\r\n}\r\n.a5d-invoice-box {\r\n  font-size: 10px;\r\n  color: #555;\r\n  position: relative;\r\n}\r\n\r\n.a5d-product-qr-code-img{\r\n  width: 148px;\r\n  height: 148px;\r\n}\r\n/* ------------------totals------------------ */\r\n\r\n.a5d-total_container {\r\n  border: 1px solid transparent;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  top: 0;\r\n  right: 6px;\r\n  /* margin-right: 6px; */\r\n}\r\n\r\n.a5d-total_container > .a5d-totals {\r\n\r\n  border: 1px solid #ddd;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, .15);\r\n  font-size: 4px;\r\n  background-color: #555;\r\n}\r\n\r\n.a5d-total_container > .a5d-totals p {\r\n\r\n  padding: 4px;\r\n  margin: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.a5d-totals_table {\r\n  border-spacing: 0;\r\n  border-collapse: collapse;\r\n  border: 0;\r\n}\r\n\r\n.a5d-totals_table tr {\r\n  padding: 16px;\r\n  border: none;\r\n  line-height: 0.8;\r\n}\r\n\r\n.a5d-totals_table td {\r\n  border: none;\r\n}\r\n\r\n.a5d-totalpayment {\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n}\r\n\r\n/* ------------------end totals------------------ */\r\n\r\n.a5d-invoice-box table {\r\n  width: 100%;\r\n  text-align: left;\r\n\r\n}\r\n\r\n.a5d-invoice-box table td {\r\n  padding: 1px;\r\n}\r\n\r\n\r\n.a5d-invoice-box table tr.top table td.logo_container {\r\n  font-size: 30px;\r\n  width: 30%;\r\n  color: #333\r\n}\r\n\r\n.a5d-invoice-box table tr.information table td {\r\n  padding-bottom: 40px\r\n}\r\n\r\n/*Dimos fix line height for email*/\r\n.a5d-main_info_table tr {\r\n  border: 1px solid #ddd;\r\n  font-weight: 700;\r\n  text-align: center;\r\n}\r\n\r\n.a5d-invoice-box table tr.details td {\r\n  padding-bottom: 20px\r\n}\r\n\r\n.a5d-invoice-box table tr.item td {\r\n  border-bottom: 1px solid #eee\r\n}\r\n\r\n.a5d-invoice-box table tr.item.last td {\r\n  border-bottom: none\r\n}\r\n\r\n.a5d-invoice-box table tr.total td:nth-child(2) {\r\n  border-top: 2px solid #eee;\r\n  font-weight: 700\r\n}\r\n\r\n.a5d-products {\r\n  border: 1px solid #eee;\r\n  text-align: center;\r\n}\r\n\r\n.a5d-products p {\r\n  height: 40px; /*Dimos increase description size*/\r\n  font-size: 10px;\r\n  margin: 4px;\r\n}\r\n\r\n.a5d-product_table .a5d-products td {\r\n  font-size: 10px;\r\n  text-align: center;\r\n  border-right: 1px solid #ddd;\r\n\r\n}\r\n\r\n.a5d-product_table .a5d-heading td {\r\n  font-size: 10px;\r\n  text-align: center;\r\n  border-right: 1px solid #ddd;\r\n  padding: 2px;\r\n}\r\n\r\n.a5d-product_table .a5d-heading p {\r\n  margin: 0;\r\n}\r\n\r\n.a5d-product_container {\r\n  margin-top: 2px;\r\n  border: 2px solid #555;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.a5d-rtl table {\r\n  text-align: right\r\n}\r\n\r\n.a5d-rtl table tr td:nth-child(2) {\r\n  text-align: left\r\n}\r\n\r\n.a5d-sender_sign {\r\n  left: 0;\r\n  margin: 0 4px;\r\n  line-height: 1;\r\n}\r\n\r\n.a5d-send_sign_container {\r\n  margin: 0;\r\n}\r\n\r\n.a5d-mydata_sign {\r\n  margin: 0 4px;\r\n  line-height: 1;\r\n}\r\n\r\n.a5d-heading {\r\n  background-color: #555;\r\n  color: white;\r\n}\r\n\r\n.a5d-main_info_table .a5d-heading > td {\r\n  line-height: 0;\r\n}\r\n\r\n.a5d-information {\r\n\r\n  border: 1px solid #555;\r\n  border-radius: 4px;\r\n  padding: 2px;\r\n\r\n}\r\n\r\n.a5d-main_info {\r\n\r\n  border: 1px solid #555;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n.a5d-skin {\r\n  color: #555;\r\n}\r\n\r\n.a5d-bold {\r\n  color: #555;\r\n  font-weight: bold;\r\n}\r\n\r\n.a5d-footer_container {\r\n  position: absolute !important;\r\n  bottom: 0;\r\n  /* border: 1px solid #ddd; */\r\n  width: 100%;\r\n  margin: auto;\r\n  padding-bottom: 0;\r\n}\r\n\r\n\r\n.a5d-header_table td {\r\n  border: none;\r\n\r\n}\r\n\r\n.a5d-issuer_container {\r\n  text-align: center;\r\n}\r\n\r\n.a5d-issuer_container .a5d-issuer_name {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n}\r\n\r\n.a5d-issuer_container .a5d-issuer_subjectField {\r\n  font-style: italic;\r\n}\r\n\r\n.a5d-issuer_container p {\r\n  margin: 0;\r\n  font-size: 10px;\r\n}\r\n\r\n.a5d-gemh_issuer_p {\r\n  font-style: italic;\r\n}\r\n\r\n.a5d-information_table {\r\n  margin-top: 2px;\r\n\r\n}\r\n\r\n.a5d-information_table td {\r\n  padding: 0;\r\n  border: none;\r\n  font-size: 8px;\r\n}\r\n\r\n.a5d-code_head_td {\r\n  width: 14%;\r\n}\r\n\r\n.a5d-description_head_td {\r\n  width: 32%;\r\n}\r\n\r\n.a5d-price_head_td {\r\n  width: 8%;\r\n}\r\n\r\n.a5d-vat_head_td {\r\n  width: 8%;\r\n}\r\n\r\n.a5d-blank_row.bordered td {\r\n  border-top: 1px solid white;\r\n  background-color: white;\r\n  max-height: 2px;\r\n  height: 2px;\r\n  line-height: 2px;\r\n}\r\n\r\n.a5d-text-right {\r\n  text-align: right;\r\n  margin-right: 20px;\r\n  background-color: white;\r\n  min-width: 30px;\r\n}\r\n\r\n.a5d-text-left {\r\n  background-color: #555;\r\n  color: white;\r\n}\r\n\r\n.a5d-info_value {\r\n  font-weight: bold;\r\n}\r\n\r\n.a5d-cont_notation {\r\n  border: 1px solid #555;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  overflow-wrap: break-word;\r\n  margin-top: 2px;\r\n  max-height: 150px;\r\n  /*width: 330px;*/\r\n}\r\n.a5d-per_vat_totals_container {\r\n  border: 1px solid #555;\r\n  border-radius: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.a5d-cont_signs {\r\n  border: 1px solid #555;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  width: 150px;\r\n}\r\n.a5d-totals_table tr{\r\n  padding: 10px;\r\n}\r\n\r\n.a5d-totals_per_vat th {\r\n  width: 10%;\r\n  color: #555;\r\n  font-weight: bold;\r\n}\r\n\r\n.a5d-total_funny_box {\r\n  width: 80px;\r\n  height: 46px;\r\n  background-color: #555;\r\n  border: 1px solid white;\r\n  border-radius: 0 0 8px 0;\r\n  position: absolute;\r\n  bottom: 60px;\r\n  right: -2px;\r\n  z-index: -1;\r\n  display: none;\r\n}\r\n\r\n.a5d-union_doc_sign {\r\n  position: absolute;\r\n  transform: rotate(-90deg);\r\n  left: -164px;\r\n  bottom: 560px;\r\n  font-size: 11px;\r\n  margin: 0;\r\n\r\n}\r\n\r\n.a5d-count_totals_container {\r\n  padding: 2px;\r\n  border: 2px solid #555;\r\n  border-radius: 8px;\r\n  min-height: 4px;\r\n  overflow: hidden;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.a5d-count_total_prods {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n}\r\n\r\n.a5d-cont_sign_left {\r\n  float: left;\r\n  text-align: center;\r\n  width: 50%;\r\n  font-size: 12px;\r\n}\r\n\r\n.a5d-cont_sign_right {\r\n  float: right;\r\n  text-align: center;\r\n  width: 50%;\r\n  font-size: 12px;\r\n}\r\n\r\n.a5d-fullname_sign {\r\n  font-size: 9px;\r\n}\r\n\r\n.a5d-sign_hr {\r\n  width: 80%;\r\n  margin: 0 0 0 10%;\r\n}\r\n\r\n.a5d-finalprice p {\r\n  font-weight: bold;\r\n  font-size: 16px !important;\r\n}\r\n\r\n.a5d-information_td_left {\r\n  width: 100%;\r\n  font-size: 8px;\r\n}\r\n\r\n.a5d-information_td_right {\r\n  /* width: 46%; */\r\n  max-height: 60px;\r\n}\r\n\r\n.a5d-up_head_td p {\r\n  font-size: 7px;\r\n}\r\n\r\n.a5d-whtax_head_td p {\r\n  font-size: 7px;\r\n  word-break: keep-all;\r\n}\r\n\r\n.a5d-pricenovat_head_td p {\r\n  font-size: 7px;\r\n}\r\n.a5d-text-head{\r\n  font-size: 10px !important;\r\n  text-decoration: underline;\r\n}\r\n.a5d-information_customer_td{\r\n  width:30%;\r\n}\r\n.a5d-cancel {\r\n  position: absolute;\r\n  transform: translate(50%) rotate(-45deg);\r\n  top: 30%;\r\n  font-size: 120px;\r\n  margin: 0 0 -200px 0;\r\n  color: #cdcdcd;\r\n  text-transform: uppercase;\r\n  opacity: 0.7;\r\n}\r\n.a5d-p {\r\n  height: 16px;\r\n  font-size: 10px;\r\n  margin: 4px;\r\n}\r\n.a5d-footer_table td {\r\n  vertical-align: bottom;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
